// businesslocations/LocationsList.js
import { useEffect, useState } from "react";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";
import LocationRow from "./LocationRow";
import LocationForm from "./LocationForm";

const LocationsList = () => {
  const { business } = useBusinessAuthContext();

  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const res = await fetch(
        `${API_URL.BUSINESS_LOCATIONS}?includeArchived=true`,
        {
          headers: {
            Authorization: `Bearer ${business.token}`,
            "x-session-id": business.sessionId,
            "x-frontend-url": window.location.pathname,
          },
        }
      );
      const data = await res.json();
      if (data.success) setLocations(data.locations);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const filtered = locations.filter((l) =>
    l.name.toLowerCase().includes(search.toLowerCase())
  );

  const total = locations.length;
  const active = locations.filter((l) => l.isActive).length;

  if (loading) return <div className="p-8">Loading locations...</div>;

  return (
    <div className="max-w-7xl mx-auto px-6">

      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <div>
          <h1 className="text-2xl font-semibold">Locations</h1>
          <p className="text-sm text-muted-foreground">
            Manage your business locations and activity
          </p>
        </div>

        <button
        onClick={() => setShowModal(true)}
        className="bg-yellow-500 hover:bg-yellow-600 px-5 py-2 rounded-full font-medium"
        >
        + Add Location
        </button>

      </div>

      {/* Stats cards */}
      <div className="flex gap-4 mb-6">
        <div className="bg-white shadow rounded-lg px-6 py-4">
          <div className="text-sm text-gray-500">Total Locations</div>
          <div className="text-xl font-semibold">{total}</div>
        </div>
        <div className="bg-white shadow rounded-lg px-6 py-4">
          <div className="text-sm text-gray-500">Active</div>
          <div className="text-xl font-semibold">{active}</div>
        </div>

        <input
          type="text"
          placeholder="Search locations..."
          className="ml-auto border rounded-md px-3 py-2"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-xl overflow-visible">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left">
            <tr>
              <th className="p-4">Name</th>
              <th>Status</th>
              <th>Address</th>
              <th>Waivers</th>
              <th>Signed</th>
              <th>QR Codes</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((loc) => (
              <LocationRow
                key={loc._id}
                location={loc}
                refresh={fetchLocations}
              />
            ))}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
            <button
                onClick={() => setShowModal(false)}
                className="absolute top-3 right-3 text-gray-500"
            >
                ✕
            </button>

            <h2 className="text-lg font-semibold mb-4">Add New Location</h2>

            <LocationForm
                onSuccess={() => {
                setShowModal(false);
                fetchLocations(); // refresh table
                }}
            />
            </div>
        </div>
        )}      



    </div>
  );
};

export default LocationsList;